/**
 * @file useOutsideFrameState.ts
 * @description Состояние «Фон за рамку сайта» секции из контекста конструктора
 * (phase19.16, партия SB120, этап 2; uiux-sb120-stage2 §3): рамка сайта из
 * оформления черновика, ширина канвы, вышел ли за рамку блок выше. Одно
 * место для поля (`OutsideFrameField`) и «!» группы «Ширина и высота»
 * (`SectionLookTab`, SB122) — предупреждение считается одинаково.
 */

import { DEFAULT_SITE_THEME, type SectionLook, type SiteTheme } from "@chaiberi/shared";
import { useContext } from "react";

import { BuilderContext, type BuilderContextValue } from "../../components/site-builder/builder-context";
import { SiteViewContext, type SiteViewContextValue } from "../../components/site-view/site-view-context";
import { outsideFrameState, prevBlockOutside, type OutsideFrameState } from "../../lib/site-builder/look-outside";

export interface OutsideFrameContext {
  state: OutsideFrameState;
  /** Ширина канвы; `null` — канвы нет. */
  canvasWidth: number | null;
  view: SiteViewContextValue | null;
  builder: BuilderContextValue | null;
}

export function useOutsideFrameState(look: SectionLook, theme: SiteTheme | null): OutsideFrameContext {
  const view = useContext(SiteViewContext);
  const builder = useContext(BuilderContext);
  const frame = (theme ?? DEFAULT_SITE_THEME).frame;
  const sel = builder?.selection.sel;
  const prevOutside = sel?.kind === "block" ? prevBlockOutside(builder?.pages.page?.blocks ?? [], sel.id, frame) : null;
  const canvasWidth = view?.preview.width ?? null;
  return { state: outsideFrameState(look, frame, canvasWidth, prevOutside), canvasWidth, view, builder };
}
